(function(){'use strict';function init(root){root=root||document;root.querySelectorAll('[data-announcement]:not([data-ready])').forEach(function(bar){bar.dataset.ready='1';var messages=bar.querySelectorAll('.announcement-line');if(messages.length<2)return;var i=0;setInterval(function(){messages[i].classList.add('is-hidden');i=(i+1)%messages.length;messages[i].classList.remove('is-hidden')},5000)});root.querySelectorAll('[data-header]:not([data-ready])').forEach(function(header){header.dataset.ready='1';var toggle=header.querySelector('[data-menu-toggle]'),nav=header.querySelector('.mobile-nav');if(toggle&&nav)toggle.addEventListener('click',function(){var isOpen=!nav.hasAttribute('hidden');if(isOpen)nav.setAttribute('hidden','');else nav.removeAttribute('hidden');toggle.setAttribute('aria-expanded',String(!isOpen))})});root.querySelectorAll('[data-product-form]:not([data-ready])').forEach(function(form){form.dataset.ready='1';var select=form.querySelector('[data-variant-select]'),btn=form.querySelector('[data-add-button]'),status=form.querySelector('[data-form-status]'),parent=form.closest('.product-info'),price=parent&&parent.querySelector('[data-product-price]'),compare=parent&&parent.querySelector('[data-compare-price]'),availability=parent&&parent.querySelector('[data-availability]');function update(){if(!select)return;var opt=select.selectedOptions[0];if(!opt)return;var ready=opt.dataset.available==='true';if(price)price.textContent=opt.dataset.price;if(compare){compare.textContent=opt.dataset.compare||'';compare.hidden=!opt.dataset.compare}if(btn){btn.disabled=!ready;btn.textContent=ready?'ADD TO CART ↗':'SOLD OUT'}if(availability)availability.textContent=ready?'Available':'Sold out';if(window.history&&history.replaceState){var u=new URL(location.href);u.searchParams.set('variant',opt.value);history.replaceState({},'',u)}}if(select){select.addEventListener('change',update);update()}form.addEventListener('submit',function(e){e.preventDefault();if(btn.disabled)return;btn.disabled=true;btn.textContent='ADDING...';status.textContent='';var data=new FormData(form);fetch('/cart/add.js',{method:'POST',body:data,headers:{'Accept':'application/json'}}).then(function(r){return r.json().then(function(j){if(!r.ok)throw new Error(j.description||'Could not add to cart');return j})}).then(function(){status.textContent='Added to your bag.';return fetch('/cart.js')}).then(function(r){return r.json()}).then(function(cart){document.querySelectorAll('.cart-count').forEach(function(n){n.textContent=cart.item_count})}).catch(function(err){status.textContent=err.message}).finally(update)})});root.querySelectorAll('[data-size-guide-open]:not([data-ready])').forEach(function(button){button.dataset.ready='1';var dialog=document.querySelector('[data-size-guide-dialog]');if(!dialog)return;button.addEventListener('click',function(){dialog.showModal()});var close=dialog.querySelector('[data-size-guide-close]');if(close)close.addEventListener('click',function(){dialog.close()});dialog.addEventListener('click',function(e){if(e.target===dialog)dialog.close()})})}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document)});else init(document);document.addEventListener('shopify:section:load',function(e){init(e.target)})})();

/* MIYORA — SHOP BY STYLE CAROUSEL */

(function () {
  'use strict';

  var reducedMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initialize(root) {
    root = root || document;

    var carousels = [];

    if (root.matches && root.matches('[data-category-carousel]')) {
      carousels.push(root);
    }

    root.querySelectorAll('[data-category-carousel]').forEach(function (item) {
      carousels.push(item);
    });

    carousels.forEach(function (carousel) {

      if (carousel.dataset.carouselReady === 'true') return;

      carousel.dataset.carouselReady = 'true';

      var slides = Array.from(
        carousel.querySelectorAll('[data-category-slide]')
      );

      if (slides.length < 2) return;

      var dots = Array.from(
        carousel.querySelectorAll('[data-category-dot]')
      );

      var previous = carousel.querySelector('[data-category-prev]');
      var next = carousel.querySelector('[data-category-next]');

      var delay = parseInt(carousel.dataset.interval, 10) || 4000;

      var timer = null;
      var current = 0;
      var startX = null;
      var startY = null;
      var lastSwipe = 0;

      var enabled = carousel.dataset.autoplay === 'true' && !reducedMotion;
      var editorSelected = false;

      function show(index) {
        current = (index + slides.length) % slides.length;

        slides.forEach(function (slide, n) {
          var active = n === current;

          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        dots.forEach(function (dot, n) {
          var active = n === current;

          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }

      function stop() {
        if (timer !== null) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      function play() {
        stop();

        if (
          !enabled ||
          editorSelected ||
          document.hidden ||
          carousel.matches(':hover') ||
          carousel.contains(document.activeElement)
        ) return;

        timer = window.setInterval(function () {
          show(current + 1);
        }, delay);
      }

      function move(to) {
        show(to);
        stop();
        play();
      }

      if (previous) {
        previous.addEventListener('click', function (event) {
          event.preventDefault();
          move(current - 1);
        });
      }

      if (next) {
        next.addEventListener('click', function (event) {
          event.preventDefault();
          move(current + 1);
        });
      }

      dots.forEach(function (dot, n) {
        dot.addEventListener('click', function (event) {
          event.preventDefault();
          move(n);
        });
      });

      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', play);

      carousel.addEventListener('focusin', stop);

      carousel.addEventListener('focusout', function () {
        window.setTimeout(play, 0);
      });

      carousel.addEventListener('touchstart', function (event) {
        if (event.touches.length !== 1) return;

        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;

        stop();
      }, { passive: true });

      carousel.addEventListener('touchend', function (event) {
        if (startX === null || !event.changedTouches.length) return;

        var deltaX = event.changedTouches[0].clientX - startX;
        var deltaY = event.changedTouches[0].clientY - startY;

        startX = null;
        startY = null;

        if (
          Math.abs(deltaX) > 35 &&
          Math.abs(deltaX) > Math.abs(deltaY) * 1.25
        ) {
          lastSwipe = Date.now();

          move(current + (deltaX < 0 ? 1 : -1));
        } else {
          play();
        }
      }, { passive: true });

      carousel.addEventListener('touchcancel', function () {
        startX = null;
        startY = null;
        play();
      }, { passive: true });

      var mediaLink = carousel.querySelector('.category-media-link');

      if (mediaLink) {
        mediaLink.addEventListener('click', function (event) {
          if (Date.now() - lastSwipe < 450) {
            event.preventDefault();
          }
        });
      }

      var visibilityHandler = function () {
        if (document.hidden) stop();
        else play();
      };

      document.addEventListener('visibilitychange', visibilityHandler);

      var owner = carousel.closest('.category-card');

      var blockSelect = function (event) {
        if (owner && event.target === owner) {
          editorSelected = true;
          stop();
        }
      };

      var blockDeselect = function (event) {
        if (owner && event.target === owner) {
          editorSelected = false;
          play();
        }
      };

      document.addEventListener('shopify:block:select', blockSelect);
      document.addEventListener('shopify:block:deselect', blockDeselect);

      carousel.categoryDestroy = function () {
        stop();

        document.removeEventListener(
          'visibilitychange',
          visibilityHandler
        );

        document.removeEventListener(
          'shopify:block:select',
          blockSelect
        );

        document.removeEventListener(
          'shopify:block:deselect',
          blockDeselect
        );
      };

      show(0);
      play();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialize(document);
    });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-category-carousel]').forEach(
      function (carousel) {
        if (carousel.categoryDestroy) {
          carousel.categoryDestroy();
        }
      }
    );
  });

})();